import $$ from 'cmn-utils'

const baseUrl = "/api/prospect/task-item/result/";
export default {
    list: (params) => {
        return $$.get(baseUrl + 'list', params)
    },
    get: (params) => {
        return $$.get(baseUrl + 'get', params)
    },
}